import { Component, OnInit, ViewChild, ElementRef, NgZone, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter, take} from "rxjs/operators";
import { AuthService } from "src/app/auth.service";
import { AdminService } from "src/app/services/admin.service";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from 'ngx-bootstrap/modal';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';

@Component({ standalone: false,
  selector: "app-navbar-public",
  templateUrl: "./navbar-public.component.html",
  styleUrls: ["./navbar-public.component.scss"]
})
export class NavbarPublicComponent implements OnInit {
  isCollapsed = true;
  @ViewChild('navList') navList!: ElementRef<HTMLElement>;

  test: Date = new Date();

  showProfileModal: boolean = false;
  profilePhotoUrl: string | null = null;

  showUserDropdown: boolean = false;

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  get username(): string {
    return this.authService.getUsername();
  }

  constructor(
    private authService: AuthService,
    private adminService: AdminService,
    public router: Router,
    public toastr: ToastrService,
    private modalService: BsModalService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isCollapsed = true;
      });

    this.profilePhotoUrl = this.authService.getProfileImageUrl();
  }


  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const navbar = document.querySelector('#navbar-main');
    if (navbar) {
      navbar.classList.toggle('scrolled', window.scrollY > 10);
    }
  }

  openChangePasswordModal(): void {
    this.modalService.show(ChangePasswordModalComponent, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: 'static',
      keyboard: false
    });
  }
  
  onProfileDropdownToggle(isOpen: boolean): void {
    this.showProfileModal = isOpen;
  }

  onPhotoUpdated(newUrl: string): void {
    this.profilePhotoUrl = newUrl;
  }

  onUserDropdownToggle(isOpen: boolean): void {
    this.showUserDropdown = isOpen;
  }

  onLogout() {
    this.adminService.logout();
  }

  // toggleNav(): void {
  //   this.isCollapsed = !this.isCollapsed;
  //   if (!this.isCollapsed) {
  //     this.ngZone.onStable.pipe(take(1)).subscribe(() => this.replaySlideIn());
  //   }
  // }

  toggleNav(): void {
      this.isCollapsed = !this.isCollapsed;
  }

  private replaySlideIn(): void {
      if (!this.navList) return;

      const rows = this.navList.nativeElement.querySelectorAll<HTMLElement>('.nav-item');

      rows.forEach((row, rowIndex) => {
        const items = row.querySelectorAll<HTMLElement>('.slide-item');
        items.forEach(el => {
          el.classList.remove('slide-in-active');
          el.style.removeProperty('--slide-delay');
          void el.offsetWidth; // force reflow PER ELEMENT, not per row
        });

        items.forEach(el => {
          el.style.setProperty('--slide-delay', `${rowIndex * 0.05}s`);
          el.classList.add('slide-in-active');
        });
      });
  }

}